import React, { useState, useRef, useEffect, useCallback } from "react";
import { redeemRewardsStyle as styles } from "./redeemRewards.tailwind";
import Rewards from "./Sections/Rewards";
import RedeemedCollectibleModal from "../../../shared/Modals/RedeemRewardsModals/RedeemedCollectibleModal/RedeemedCollectibleModal";
import { connect, useSelector } from "react-redux";
import { fetchUserRewards } from "../../../../redux/slices/rewardSlice";
import OverlayLoader from "../../../shared/Loaders/OverlayLoader/OverlayLoader";

const RedeemRewardsSection = ({ fetchUserRewards }) => {
  const apiDataRef = useRef(false);
  const [activeModal, setActiveModal] = useState(null);

  // Retrieve seasonId from the Redux store
  const { currentSeason } = useSelector((state) => state.seasons);
  const seasonId = currentSeason?._id;
  const { claimingReward } = useSelector((state) => state.reward);

  const handleCloseModal = () => setActiveModal(null);

  const callApi = useCallback(async () => {
    if (apiDataRef.current) return;
    apiDataRef.current = true;

    // data to be sent in getRewards
    const data={
      seasonId
    }

    await fetchUserRewards(data); 
  }, [fetchUserRewards, seasonId]);

  useEffect(() => {
    if (seasonId) {
      callApi();
    }

    return () => {
      apiDataRef.current = false;
    }
  }, [callApi, seasonId, currentSeason]);

  return (
    <div className={styles.outerContainer}>
      {/* Show Loader */}
      {claimingReward && <OverlayLoader />}

      {/* Available Rewards */}
      <Rewards />

      {activeModal === "bonusPoints" && <RedeemedCollectibleModal isOpen={true} onClose={handleCloseModal} />}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  fetchUserRewards: (seasonId) => dispatch(fetchUserRewards(seasonId)), // Modify to accept seasonId
});

export default connect(null, mapDispatchToProps)(RedeemRewardsSection);
